import * as React from 'react';
import {
    IBuyboxState
} from '@msdyn365-commerce-modules/buybox';
import { IRwbBuyboxProps } from './rwb-buybox.props.autogenerated';
import { IRwbBuyboxData } from './rwb-buybox.data';

const _getClassNamePrefix = (typeName: string): string => {
    return typeName.toLocaleLowerCase() === 'quickview' ? 'rwb-quickView' : 'rwb-buybox';
};

export function getTotalInventory(
    props: IRwbBuyboxProps<IRwbBuyboxData>,
    state: IBuyboxState
): React.ReactElement | undefined {

    const { typeName } = props;
    var className = _getClassNamePrefix(typeName);
    var totalInventoryClassName = `${className}__totalInventory`;
    var totalInventory = 0;
    var storeNum = 0;

    var preferredStore = props.data.storeSelectorStateManager.result?.preferredStore;
    var preferredStoreInventory = 0;
    var preferredStoreName ='';

    var availabilities = props.data.availabilitiesWithHours.result;
    availabilities?.forEach (availability=>{
            var itemAvailabilities = availability.OrgUnitAvailability?.ItemAvailabilities;
            var inventory = 0;
            if (itemAvailabilities && itemAvailabilities[0]) {
                inventory = itemAvailabilities[0].AvailableQuantity?itemAvailabilities[0].AvailableQuantity:0;
                storeNum++;
                if (availability.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === preferredStore?.StoreId) {
                    preferredStoreInventory = itemAvailabilities[0].AvailableQuantity?itemAvailabilities[0].AvailableQuantity:0;
                    preferredStoreName = preferredStore?.StoreName? preferredStore?.StoreName:'';
                }
            }
            totalInventory += inventory;
    });

    if (preferredStore) {
        if (preferredStoreInventory === 0) {
            totalInventoryClassName += '__notInStock';
            return (
                <div className={totalInventoryClassName}>
                    Not in stock in {preferredStoreName}
                </div>
            );
        }
        return (
            <div className={totalInventoryClassName}>
                {preferredStoreInventory} in stock in {preferredStoreName}
            </div>
        );
    } else {
        if (totalInventory === 0) {
            totalInventoryClassName += '__notInStock';
            return (
                <div className={totalInventoryClassName}>
                    Not in stock in {storeNum} shops
                </div>
            );
        }
        return (
            <div className={totalInventoryClassName}>
                {totalInventory} in stock in {storeNum} shops
            </div>
        );
    }
}